'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var fetchNext = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2) {
    var reference = _ref2.reference,
        skip = _ref2.skip,
        populate = _ref2.populate;

    var _ref3, pagination, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _methods.get)({
              url: '/api/model/' + reference,
              query: {
                populate: populate,
                limit: 65536,
                skip: skip
              }
            });

          case 2:
            _ref3 = _context.sent;
            pagination = _ref3.pagination;
            data = _ref3.data;
            return _context.abrupt('return', [pagination, data]);

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchNext(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchOptions = function () {
  var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_ref5) {
    var reference = _ref5.reference,
        populate = _ref5.populate;

    var counter, options, _ref6, _ref7, pagination, fetched;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isFetching[reference]) {
              _context2.next = 2;
              break;
            }

            throw new Error('isFetching');

          case 2:

            isFetching[reference] = true;

            counter = createCounter();
            options = [];

          case 5:
            if (!counter.hasNext()) {
              _context2.next = 16;
              break;
            }

            _context2.next = 8;
            return fetchNext({
              reference: reference,
              skip: counter.fetched,
              populate: populate
            });

          case 8:
            _ref6 = _context2.sent;
            _ref7 = _slicedToArray(_ref6, 2);
            pagination = _ref7[0];
            fetched = _ref7[1];


            options = options.concat(fetched);
            counter.add(pagination);
            _context2.next = 5;
            break;

          case 16:

            isFetching[reference] = false;
            return _context2.abrupt('return', options);

          case 18:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchOptions(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var _methods = require('./methods');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function createCounter() {
  var total = 65536;
  var fetched = 0;

  return {
    total: total,
    fetched: fetched,
    add: function add(pagination) {
      total = Math.min(total, pagination.total);
      fetched += pagination.limit;
    },
    hasNext: function hasNext() {
      return fetched < total;
    }
  };
}

var isFetching = {};
exports.default = fetchOptions;


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/codev-api/fetchOptions.js
// module id = 1052
// module chunks = 0